import styled from "styled-components";

import { BillboardStyledProps as Props } from "./Billboard.types";
import CONSTANTS from "config/constants";

const { mobile, tablet, desktop, wide } = CONSTANTS.BREAKPOINTS;

const BillboardStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr max-content;

  .Billboard {
    &__header {
      grid-column: fullBleed;
    }

    &__cinema {
      display: none;
      @media (max-width: ${tablet}px) {
        display: block;
        margin-bottom: 2.4rem;
      }
    }

    &__main {
      flex: 1;
      display: flex;
      flex-direction: column;
      grid-column: content;
      padding-top: 14rem;
      padding-bottom: 4rem;

      @media (max-width: ${tablet - 1}px) {
        padding-top: 12rem;
      }

      &__movies {
        display: ${props =>
          props.isPremiere || props.isPreview ? "flex" : "grid"};
        flex-direction: ${props =>
          props.isPremiere || props.isPreview ? "column" : "unset"};
        grid-column: fullBleed;
        grid-template-columns: ${props =>
          props.noMovies ? "auto" : "repeat(6, 1fr)"};
        justify-content: center;
        gap: ${props => (props.noMovies ? "0" : "2.4rem 0")};
        padding: 0 6rem;

        @media (max-width: ${wide}px) {
          grid-template-columns: ${props =>
            props.noMovies ? "auto" : "repeat(5, 1fr)"};
        }

        @media (max-width: ${wide - 1}px) {
          grid-template-columns: ${props =>
            props.noMovies ? "auto" : "repeat(4, 1fr)"};
        }

        @media (max-width: ${desktop - 1}px) {
          grid-template-columns: ${props =>
            props.noMovies ? "auto" : "repeat(3, 1fr)"};
        }

        @media (max-width: ${tablet}px) {
          padding: ${props => (props.isPremiere ? "0 6rem" : "0 6rem")};
        }

        @media (max-width: ${tablet - 1}px) {
          grid-template-columns: auto auto;
          column-gap: ${props => (props.noMovies ? "0" : "2.4rem")};

          padding: ${props => (props.isPremiere ? "0 0.8rem" : "0 6rem")};
        }

        @media (max-width: ${mobile - 100}px) {
          grid-template-columns: auto;
        }

        .MovieCard {
          justify-self: center;
        }
      }

      &-header {
        @media (max-width: ${tablet}px) {
          margin-bottom: 4rem;
        }
      }
    }

    &__button {
      font-size: 2rem;
      font-weight: 600;
      background-color: unset;
      border: unset;
      width: max-content;
      color: var(--palette-white);
      padding: 0;
      box-shadow: unset;

      &:hover:not([disabled]) {
        background-color: transparent;
        border: unset;
        box-shadow: unset;
      }

      @media (max-width: ${tablet}px) {
        font-size: 1.8rem;
      }

      &__icon {
        margin-right: 0.4rem;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;

      &--loading {
        svg {
          height: 6.4rem;
          width: 6.4rem;
          animation: rotate 0.6s linear infinite;
        }
      }
    }

    &__filter {
      display: flex;
      padding: 1.6rem 2.4rem;
      color: var(--palette-white);

      &:hover {
        border-bottom: 0.1rem solid transparent;
      }

      @media (max-width: ${tablet}px) {
        padding-left: 0;
        padding-right: 3.2rem;
      }
    }

    &__tabs {
      margin-bottom: 4.8rem;
      display: flex;
      padding-bottom: 0.8rem;
      width: 100%;
      scroll-snap-type: x proximity;
      position: relative;
      scrollbar-width: none;

      @media (min-width: ${tablet}px) {
        justify-content: center;
      }

      .ScrollableTabs {
        width: initial;
      }
    }

    &__scrollable {
      display: flex;
    }

    &__menu {
      display: flex;
      flex-direction: column;
      padding-right: 3.2rem;
    }

    &__item {
      color: var(--palette-white);
      padding-right: 4rem;
      font-size: 1.6rem;
      font-weight: 600;
    }

    &__active {
      border-bottom: 0.1rem solid var(--palette-white);
      width: 4.8rem;
      position: relative;
      top: 1.2rem;
    }

    &__placeholder {
      display: contents;

      @media (max-width: ${mobile - 1}px) {
        display: flex;
      }
    }

    &__footer {
      grid-column: fullBleed;
      padding-top: 3.2rem;
      display: ${props => (props.talkShop ? "none" : "content")};
    }

    &__empty {
      background-color: var(--palette-primary);
      border-radius: 0.8rem;
      width: max-content;
      padding: 1.6rem 2.4rem;

      &__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
`;

export default BillboardStyled;
